import type { RVezyGisGeocode, RvezyGisPlace, RvezyGeoCodeResponse, RvezyPlaceResponse } from '~/types/api'

export class GeocoderService {

  async getGeocode(searchAddress: string): Promise<RVezyGisGeocode | undefined> {
    if (!searchAddress) {
      return
    }
    try {
      const geoData = await $fetch('/api/gis/geocode', {
        query: {
          Address: searchAddress
        }
      }) as RvezyGeoCodeResponse
      return geoData?.results?.[0]
    } catch (e) {
      return
    }
  }

  async getPlaceDetails(placeId?: string | null): Promise<RvezyGisPlace | undefined> {
    if (!placeId) {
      return
    }
    try {
      const place = await $fetch('/api/gis/place', {
        query: {
          PlaceId: placeId,
          Fields: 'address_components,geometry,types,formatted_address'
        }
      }) as RvezyPlaceResponse

      return (place?.result as RvezyGisPlace) ?? undefined
    } catch (e) {
      return
    }
  }
}
